import {
  ConnectionStatus,
  type CalendarConnection,
} from "@photography-booking/shared";

/** 24 hours: about 48 missed runs of the 30-minute calendar sync. */
export const STALE_SYNC_THRESHOLD_MS = 24 * 60 * 60 * 1000;

/**
 * True when a connection that isn't already flagged ERROR hasn't synced
 * successfully for more than 24 hours. An ERROR connection already shows
 * "Reconnect needed", and a connection that has never synced has nothing to
 * compare.
 */
export function isConnectionStale(
  connection: Pick<CalendarConnection, "status" | "lastSuccessfulSyncAt">,
  nowMs: number,
): boolean {
  if (connection.status === ConnectionStatus.ERROR) return false;
  if (!connection.lastSuccessfulSyncAt) return false;
  const lastMs = Date.parse(connection.lastSuccessfulSyncAt);
  return Number.isFinite(lastMs) && nowMs - lastMs > STALE_SYNC_THRESHOLD_MS;
}
